import { Text } from "@accurx/design";
import styled from "styled-components";

export const StyledText = styled(Text)`
    margin-bottom: 2;
`;
